/** Safari/iOS 16.4+ exposes the shared audio session. Speech can report
 * `onstart` while the default ambient session is muted by the silent switch.
 * Request media playback for the reader, then restore the previous mode.
 */
export interface AudioSessionLike {
  type: string
}

export function browserAudioSession(): AudioSessionLike | null {
  if (typeof navigator === 'undefined') return null
  try {
    return (navigator as Navigator & { audioSession?: AudioSessionLike }).audioSession ?? null
  } catch {
    return null
  }
}

export function activatePlaybackSession(session: AudioSessionLike | null): () => void {
  if (!session) return () => {}
  let previous: string
  try {
    previous = session.type
    if (previous === 'playback') return () => {}
    session.type = 'playback'
  } catch {
    // Unsupported/locked-down browser: continue with native speech.
    return () => {}
  }
  return () => {
    try {
      // Do not overwrite a subsequent session change made by another player.
      if (session.type === 'playback') session.type = previous
    } catch {
      // Session availability may change when the page is hidden.
    }
  }
}
